// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.cards-list[data-v-92d37e78]{padding-bottom:1rem}@media (min-width:1024px){.card-container.card[data-v-92d37e78]{padding-right:2.4rem}}.card-container.card[data-v-92d37e78]:not(:last-child){margin-bottom:2.4rem}@media (max-width:767px){.card-container.card[data-v-92d37e78]:not(:last-child){margin-bottom:1.6rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
